import { Card, Col, Row, Descriptions } from 'antd';
import { useEgresadoContext } from './../../../context/EgresadoProvident';


const InfoUser = ({ id }) => {

    const { alumno } = useEgresadoContext();
    const info_aca_cona = alumno?.exp_academica?.find(item => item.sae);

    const items = [
        {
            key: '1',
            label: 'Plantel',
            children: info_aca_cona?.plantel?.nombre_plantel || info_aca_cona?.institucion || 'No disponible',
            span: 4,
        },
        {
            key: '2',
            label: 'Carrera',
            children: info_aca_cona?.carrera?.nombre || info_aca_cona?.nombre || 'No disponible',
            span: 4,
        }, 
        {
            key: '4',
            label: 'CURP',
            children: alumno?.curp,
            span: 2,
        },
        {
            key: '5',
            label: 'Matrícula',
            children: info_aca_cona?.matricula ?? 'No disponible',
            span: 2,
        },
        {
            key: '6',
            label: 'Estatus',
            children: info_aca_cona?.estatus_formacion ?? 'No disponible',
            span: 2,
        },
        info_aca_cona?.valor_cedula && {
            key: '7',
            label: 'Núm. de cédula',
            children: info_aca_cona?.valor_cedula ?? 'No disponible',
            span: 2,
        },
        info_aca_cona?.valor_titulo && {
            key: '8',
            label: 'Núm. de título',
            children: info_aca_cona?.valor_titulo ?? 'No disponible',
            span: 2,
        }
    ].filter(Boolean);

    return (
        <>
            <Card id={id} loading={!alumno}>
                <Row>
                    <Col span={24}>
                        <Descriptions
                            id='infoUser'
                            title="Información proveniente del expediente académico institucional"
                            bordered
                            size='small'
                            items={items}
                            column={4}
                        />
                    </Col>
                </Row>
            </Card>
        </>
    );
};

export default InfoUser;